import { cloneDeep } from 'lodash-es';
import type { LegacyComposerDocument, LegacyComposerSectionProps, SectionTypes } from '../../content-composer/types';
import { migrateButtonSection } from '../../utils/legacy-migration/migrate-button-section';
import { migrateCustomCodeSection } from '../../utils/legacy-migration/migrate-custom-code-section';
import { migrateFooterSection } from '../../utils/legacy-migration/migrate-footer-section';
import { migrateImageSection } from '../../utils/legacy-migration/migrate-image-section';
import { migrateLogoSection } from '../../utils/legacy-migration/migrate-logo-section';
import { migrateTextSection } from '../../utils/legacy-migration/migrate-text-section';

export const emailComposerMigrateLegacyToSchemaType = (
  parsedTemplateJson: LegacyComposerDocument
): { formattedSections?: { sections?: SectionTypes[] }; invalidSections?: LegacyComposerSectionProps[] } => {
  if (!parsedTemplateJson) return { formattedSections: undefined };
  const oldSections = cloneDeep(parsedTemplateJson.sections);
  if (!oldSections || !Array.isArray(oldSections)) return { formattedSections: undefined };
  const invalidSections: LegacyComposerSectionProps[] = [];
  const sections = oldSections
    ?.map((section) => {
      const type = section.type;

      switch (type) {
        case 'ButtonSection':
          return migrateButtonSection(section);
        case 'CustomCodeSection':
          return migrateCustomCodeSection(section);
        case 'FooterSection':
          return migrateFooterSection(section);
        case 'ImageSection':
          return migrateImageSection(section);
        case 'LogoSection':
          return migrateLogoSection(section);
        case 'TextSection':
          return migrateTextSection(section);
        default:
          invalidSections.push(section);
          return undefined;
      }
    })
    .filter((section): section is NonNullable<SectionTypes> => !!section);

  return { formattedSections: { sections }, invalidSections };
};
